/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiCommandAuditLog } from '@Model';
import type { HttpActions, ListInfo, ListRequest, ListRequestWithIds, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of CommandAuditLogsController.
 */
export class CommandAuditLogsRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls GET /command_audit_logs:query
     */
    public getListGet(pageNo: number, pageSize: number, include: string | undefined): Promise<Result<ListInfo<ApiCommandAuditLog>>> {
        const query = new URLSearchParams();
        query.set('pageNo', `${pageNo}`);
        query.set('pageSize', `${pageSize}`);
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ListInfo<ApiCommandAuditLog>>>('/command_audit_logs:query', query);
    }

    /**
     * Calls POST /command_audit_logs:query
     */
    public getListPost(listRequest: ListRequest, include: string | undefined): Promise<Result<ListInfo<ApiCommandAuditLog>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiCommandAuditLog>>, ListRequest>('/command_audit_logs:query', listRequest, query);
    }

    /**
     * Calls GET /command_audit_logs/{primaryId}
     */
    public get(primaryId: string, include: string | undefined): Promise<Result<ApiCommandAuditLog>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ApiCommandAuditLog>>(`/command_audit_logs/${primaryId}`, query);
    }

    /**
     * Calls POST /command_audit_logs:batch
     */
    public getBatch(listRequest: ListRequestWithIds, include: string | undefined): Promise<Result<ListInfo<ApiCommandAuditLog>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiCommandAuditLog>>, ListRequestWithIds>('/command_audit_logs:batch', listRequest, query);
    }
}
